import React from 'react';
import variables from '../../styles/variables.module.scss';
import Highlight from '../../components/Highlight';

import environments1 from '../../assets/envImages/easyeducation-env1-min.jpg';
import environments2 from '../../assets/frames/easyeducation-env-coolStudent.jpg';

import hero from '../../assets/hero/easyeducation-hero-min.jpg';
import extraimg1 from '../../assets/frames/easyeducation-extraimg1-min.jpg';
import extraimg2 from '../../assets/frames/easyeducation-extraimg2-min.jpg';
import extraimg3 from '../../assets/frames/easyeducation-extraimg3-min.jpg';
import footerBanner from '../../assets/envImages/easyeducation-footerBanner-min.jpg';

export default {
  path: '/cases/easy-education',
  color: variables.easyEducation,
  hero: { fall: hero },
  environments: { env1: environments1, env2: environments2 },
  // footerBanner: { fall: imageLarge1Alt },
  web1: { fall: extraimg1 },
  web2: { fall: extraimg2 },
  web3: { fall: extraimg3 },
  footerBanner: { fall: footerBanner },
  isWeb: true,
  quoteData: {
    quote: 'We App has been a great partner from day one. They quickly helped narrow down our idea into clear milestones. Overall, we have been extremely satisfied with their work, and are looking forward to continuing our partnership.',
    name: 'Gustav Ahlm',
    profession: 'Co-Founder & CEO, Easy Education Sweden AB',
  },
  title: 'Easy Education',
  sideHeadingFirst: 'Web application',
  sideHeadingSecond: 'Develop in React with Material UI',
  infoTitle: 'What we built',
  infoBody:
  <span>
    Easy education is a modern web-app built in
    {' '}
    <Highlight>ReactJS</Highlight>
    {' with '}
    <Highlight>GraphQL</Highlight>
    . It contains a powerful HTML-editor, that converts text books to HTML text format. The advantage of this format is the number of features it enables, such as the manipulation and customization of text, to suit the different work styles of different students. The powerful HTML-editor now allow the text within books to be marked, highlighted, searched for, summarized, or manipulated in any of the other ways, which you normally use to customize text in a writing editor, such as e.g. Microsoft Word.
    <br />
    <br />
    The solution is meant to simplify the lives of students and help them manage their school-work more efficiently.
  </span>,
  infoData: {
    Scope: ['Scope', 'Project management', 'User experience', 'UI & UX design'],
    Deliverables: ['Deliverables', 'iOS development', 'Android development', 'Cross-platform', 'Software development'],
    Goal: ['Goal', 'Project management', 'User experience', 'UI & UX design', 'Maintanance/support'],
  },
  titleBodyData: {
    0: {
      title: 'Education in the digital era',
      body:
  <span>
    We're proud to have been working as technology partner to Easy Education, an education and learning software for the digital era.
    <br />
    <br />
    Easy education is a powerful web app, to be used by students in their everyday school-work. The system is integrated to Sweden’s biggest publishers of school literature. And allow students the access to a vast selection of digital literature. But hey, it doesn’t stop there!
  </span>,
    },
    1: {
      title: 'Putting the word easy into education',
      body: 'What if you could connect your digital literature to your own, and your class-mates shared note-taking, to your highlights, your bookmarks, to powerful search features, and features meant to summarize it all for you automatically? Well, that’s Easy education for you.',
    },
  },
};
